"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var React = require("react");
var store_1 = require("../data/store/store");
var owa_session_store_1 = require("owa-session-store");
var mobx_1 = require("mobx");
var getFilteredTimeFormatOptions_1 = require("../utils/getFilteredTimeFormatOptions");
var selectTimeFormatOption_1 = require("../data/mutators/selectTimeFormatOption");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var owa_datetime_format_1 = require("owa-datetime-format");
var EXAMPLE_START_RANGE = new Date(2017, 8, 1, 1, 1);
var EXAMPLE_END_RANGE = new Date(2017, 8, 1, 23, 59);
var TimeFormatSelection = /** @class */ (function (_super) {
    tslib_1.__extends(TimeFormatSelection, _super);
    function TimeFormatSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeFormatSelection.prototype.render = function () {
        var savedTimeFormat = owa_session_store_1.getUserConfiguration().UserOptions.TimeFormat;
        var selectedKey = store_1.default().selectedTimeFormat || savedTimeFormat;
        if (getFilteredTimeFormatOptions_1.default().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredTimeFormatOptions_1.default().indexOf(savedTimeFormat) === -1
                    ? getFilteredTimeFormatOptions_1.default()[0]
                    : savedTimeFormat;
        }
        return (React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_timeFormat, options: this.timeFormatOptions, selectedKey: selectedKey, onChanged: this.onSelectDateFormat }));
    };
    TimeFormatSelection.prototype.onSelectDateFormat = function (item) {
        selectTimeFormatOption_1.default(item.key);
    };
    Object.defineProperty(TimeFormatSelection.prototype, "timeFormatOptions", {
        get: function () {
            return getFilteredTimeFormatOptions_1.default().map(function (shortTimeFormat) {
                return {
                    text: owa_datetime_format_1.formatDate(EXAMPLE_START_RANGE, shortTimeFormat, false) + " - " + owa_datetime_format_1.formatDate(EXAMPLE_END_RANGE, shortTimeFormat, false),
                    key: shortTimeFormat,
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], TimeFormatSelection.prototype, "timeFormatOptions", null);
    TimeFormatSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], TimeFormatSelection);
    return TimeFormatSelection;
}(React.Component));
exports.default = TimeFormatSelection;
//# sourceMappingURL=TimeFormatSelection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/view/TimeFormatSelection.js
// module id = 4940
// module chunks = 2